import ExampleCodeBlock from 'components/Docs/ExampleCodeBlock'

export function UpdateSdkUserCredentialsCodeExample() {
  const js = `await integrationApp.self.patch({ credentials: newCredentials })`

  return <ExampleCodeBlock customCodes={{ js }} />
}
